import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Button, TextField, Select, ResourceList, Tag, Banner } from '@shopify/polaris'
import { ResourcePicker } from '@shopify/polaris/embedded'
import IconSearch from 'react-icons/lib/fa/search'
import generate from 'firebase-auto-ids'

import { setCustomField, updateNumberOfSlidesSimple, updateCustomStyleEffect } from 'controllers/logic'
import { fontSize, SHOPIFY_GRAY } from 'components/styles'
import { setShopifyBarTitle } from 'controllers/shopifyBar'
import UICard from './shopifyUI/UICard'
import ProductCard from './addCollection/ProductCard'
import CollectionProductsList from './addCollection/CollectionProductsList'
import Text from 'components/common/Text'
import { HIDDEN } from 'constants/stylePresetType'
import { collectionsByProduct } from 'controllers/shopifyApp'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${SHOPIFY_GRAY};
  display: flex;
  _align-items: center;
  ${fontSize}
  line-height: 1;
  justify-content: center;
  margin-top: 3em;

  & .Polaris-Label {
    font-size: 0.6em;
  }
`

const EditorContainer = styled.div`
  ${fontSize}
  max-width: 64em;
  height: 100%;

  & .Polaris-Card {
    height: 100%;
    max-height: calc(100% - 4em);
    display: flex;
    flex-direction: column;
  }

  & .Polaris-Card__Section {
    display: flex;
    flex-direction: column;
    flex-grow: 10;
  }
`
const FooterRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const ButtonContainer = styled.div`
  margin-right: 1em
`
const ContentContainer = styled.div`
  border-top: solid 1px #dfe3e8;
  border-bottom: solid 1px #dfe3e8;
  margin-bottom: 1em;
  display: flex;
  flex-direction:column;
`
const InputsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
`
const CollectionsSelectContainer = styled.div`
  width: 18em;
`
const SearchProductContainer = styled.div`
  width: 18em;
`
const BannerContainer = styled.div`
  font-size: 0.8em;
`

class AddCollection extends Component {

  constructor (props) {
    super(props)
    const { p0, p1 } = this.initProducts(props)
    this.state = {
      productsPickerVisible: false,
      collectionsPickerVisible: false,
      p0,
      p1,
      collectionsOptions: this.makeCollectionsOptions(props),
      selectedCollection: -1
    }
    this.productsCollectionsDict = {}
    setShopifyBarTitle('Product scenes / Collections')
  }

  makeCollectionsOptions (props) {
    const res = _.map(props.collections, c => {
      return {
        value: c.id,
        label: c.title
      }
    })
    res.push({value: -1, label: 'None'})
    return res
  }

  initProducts (props) {
    const { app, editShowcaseIdx, dispatch } = props
    const currentProducts = _.get(app, ['customFields', 'showcases', editShowcaseIdx, 'products'], [])
    const res = {
      p0: _.get(props.integrationProducts, _.get(currentProducts, [0, 'productId'])),
      p1: _.get(props.integrationProducts, _.get(currentProducts, [1, 'productId'])),
    }
    // console.log('initProducts return ', res)
    if (res.p0) dispatch(collectionsByProduct(res.p0.productId, this.onCollectionsByProducts))
    if (res.p1) dispatch(collectionsByProduct(res.p1.productId, this.onCollectionsByProducts))
    return res
  }

  componentWillReceiveProps (nextProps) {
    if (_.size(nextProps.integrationProducts) !== _.size(this.props.integrationProducts)) {
      const { p0, p1 } = this.initProducts(nextProps)
      this.setState({p0, p1})
    }
    if (nextProps.editShowcaseIdx !== this.props.editShowcaseIdx) {
      const { p0, p1 } = this.initProducts(nextProps)
      this.setState({
        productsPickerVisible: false,
        collectionsPickerVisible: false,
        p0,
        p1,
        selectedCollection: -1
      })
    }
  }

  renderBackButton () {
    const { stopAddCollection } = this.props
    return (
      <ButtonContainer>
        <Button
          size='slim'
          onClick={() => stopAddCollection(true, false)}
        >
          {'Back'}
        </Button>
      </ButtonContainer>
    )
  }

  apply = (toNextStep) => {
    return () => {
      const { dispatch, stopAddCollection, editShowcaseIdx, app } = this.props
      const { p0, p1 } = this.state
      console.log('apply, editShowcaseIdx', editShowcaseIdx, 'p0', p0, 'p1', p1)
      let showcase
      let showcaseNum = editShowcaseIdx
      if (_.isNil(editShowcaseIdx)) {
        // creating new product scene
        showcase = {
          slideId: generate(_.now()),
          image: null,
          products: [
            {
              x: 10,
              y: -22,
              title: _.get(p0, 'title', null),
              productId: _.get(p0, 'productId', null)
            },
            {
              x: 10,
              y: 22,
              title: _.get(p1, 'title', null),
              productId: _.get(p1, 'productId', null)
            }
          ]
        }
        showcaseNum = app.slidesCnt
        dispatch(updateNumberOfSlidesSimple(app.id, app.slidesCnt + 1))
      } else {
        showcase = _.clone(_.get(app, ['customFields', 'showcases', editShowcaseIdx]))
        _.set(showcase, ['products', 0, 'title'], _.get(p0, 'title', null))
        _.set(showcase, ['products', 0, 'productId'], _.get(p0, 'productId', null))
        _.set(showcase, ['products', 1, 'title'], _.get(p1, 'title', null))
        _.set(showcase, ['products', 1, 'productId'], _.get(p1, 'productId', null))
        // modify existing product scene
      }

      const collections0 = _.get(this.productsCollectionsDict, _.get(p0, 'productId'), [])
      const c0 = _.get(collections0, 0)
      const collections1 = _.get(this.productsCollectionsDict, _.get(p1, 'productId'), [])
      const c1 = _.get(collections1, 0)

      // const showcaseImageExists = _.has(showcase, 'image')
      // if (!showcaseImageExists) {
        const productImage = _.get(p0, ['details', 'images', 0], _.get(p1, ['details', 'images', 0]))
        if (productImage) {
          showcase.image = productImage
        }

        const image0 = _.get(c0, 'image')
        if (image0 && image0.height > 500) {
          showcase.image = image0.src
        } else if (image0 && image0.height > 500) {
          showcase.image = image0.src
        }
      // }

      // creating scene name
      const title = _.get(c0, 'title', _.get(c1, 'title'))
      if (title) {
        showcase.name = title
      }

      dispatch(setCustomField(app.id, `showcases/${showcaseNum}`, showcase))
      dispatch(updateCustomStyleEffect(app, `ou_showcase_link_p${showcase.slideId}_0`, HIDDEN, { value: p0 ? null : true }))
      dispatch(updateCustomStyleEffect(app, `ou_showcase_link_p${showcase.slideId}_1`, HIDDEN, { value: p1 ? null : true }))
      stopAddCollection(false, toNextStep)
    }
  }

  renderRight () {
    const { p0, p1 } = this.state
    return (
      <FooterRight>
        {this.renderBackButton()}
        <Button
          primary
          onClick={this.apply(false)}
          size='slim'
          disabled={_.isNil(p0) && _.isNil(p1)}
        >
          {'Done'}
        </Button>
      </FooterRight>
    )
  }

  showProductPicker = () => {
    this.setState({productsPickerVisible: true})
  }

  showCollectionsPicker = () => {
    this.setState({collectionsPickerVisible: true})
  }

  onCollectionChange = (newValue, id) => {
    // console.log('onCollectionChange', newValue, id)
    this.setState({selectedCollection: newValue})
  }

  renderCollectionsSelect () {
    const { collectionsOptions, selectedCollection } = this.state
    const { collections } = this.props
    if (selectedCollection === -1) {
      return (
        <CollectionsSelectContainer innerRef={this.onCollectionsSelectMounted}>
          <Select
            placeholder='None'
            label='Choose existing collection'
            // onFocus={this.showCollectionsPicker}
            options={collectionsOptions}
            value={selectedCollection}
            onChange={this.onCollectionChange}
          />
        </CollectionsSelectContainer>
      )
    } else {
      const collectionName = collections[selectedCollection].title
      return (
        <div>
          <div className='Polaris-Labelled__LabelWrapper'>
            <div className='Polaris-Label'>
              <label className='Polaris-Label__Text'>
                Choose existing collection
              </label>
            </div>
          </div>
          <Tag onRemove={() => this.onCollectionChange(-1)}>{collectionName}</Tag>
        </div>
      )
    }
  }

  renderInputs () {
    if (!this.bothProductsSet()) {
      return (
        <InputsContainer>
          {this.renderCollectionsSelect()}
          <SearchProductContainer>
            <TextField
              ref={this.onProductsInputMounted}
              label='Search products'
              prefix={<IconSearch size='1.2em' color='rgb(168, 168, 168)' />}
              placeholder='Search products'
              onFocus={this.showProductPicker}
            />
          </SearchProductContainer>
        </InputsContainer>
      )
    }
  }

  onCollectionsByProducts = (res) => {
    // console.log('onCollectionsByProducts', res)
    _.set(this.productsCollectionsDict, res.productId, res.collections)
  }

  addProduct = (productId) => {
    const { dispatch, integrationProducts } = this.props
    // const { selectedCollection } = this.state
    const product = integrationProducts[productId]
    // if (selectedCollection >= 0) {
    //   product.collections = [selectedCollection]
    // } else {
    if (!this.productsCollectionsDict[productId]) {
      dispatch(collectionsByProduct(productId, this.onCollectionsByProducts))
    }
    // }
    // console.log('addProduct', product)
    const { p0, p1 } = this.state
    if (_.isNil(p0)) {
      this.setState({p0: product})
    } else if (_.isNil(p1)) {
      this.setState({p1: product})
    }
  }

  productSelected = (products = []) => {
    // console.log('productSelected', products)
    this.setState({productsPickerVisible: false})
    if (products.length > 0) {
      this.addProduct(products[0].id)
    }
  }

  collectionSelected = (collections = []) => {
    // console.log('collectionSelected', collections)
    this.setState({
      collectionsPickerVisible: false,
      selectedCollection: _.get(collections, [0, 'id'], this.state.selectedCollection)
    })
  }

  renderProductsPicker () {
    const { productsPickerVisible } = this.state
    if (productsPickerVisible) {
      return (
        <ResourcePicker
          products
          allowMultiple={false}
          open={productsPickerVisible}
          onSelection={(resources) => this.productSelected(resources.products)}
          onCancel={() => this.productSelected()}
        />
      )
    }
  }

  renderCollectionsPicker () {
    const { collectionsPickerVisible } = this.state
    if (collectionsPickerVisible) {
      return (
        <ResourcePicker
          collections
          allowMultiple={false}
          open={collectionsPickerVisible}
          onSelection={(resources) => this.collectionSelected(resources.collections)}
          onCancel={() => this.collectionSelected()}
        />
      )
    }
  }

  bothProductsSet = () => {
    const { p0, p1 } = this.state
    // console.log('bothProductsSet', p0, p1)
    return !_.isNil(p0) && !_.isNil(p1)
  }

  deleteProduct = (productId) => {
    const { p0, p1 } = this.state
    // console.log('deleteProduct', productId, 'p0, p1', p0, p1)
    if (_.get(p0, 'productId') === productId) this.setState({p0: undefined})
    if (_.get(p1, 'productId') === productId) this.setState({p1: undefined})
  }

  renderProduct = (productInfo) => {
    // console.log('renderProduct', productInfo)
    if (productInfo) {
      return (
        <ProductCard
          productId={productInfo.productId}
          title={productInfo.title}
          image={productInfo.details.images[0]}
          onDelete={this.deleteProduct}
        />
      )
    }
  }

  renderSceneProducts = () => {
    const { p0, p1 } = this.state
    return (
      <ResourceList
        items={[p0, p1]}
        renderItem={this.renderProduct}
      />
    )
  }

  onChangeDesignButtonPressed = () => {
    this.apply(true)
  }

  renderCollectionProducts = () => {
    const { collections } = this.props
    const { selectedCollection, p0, p1 } = this.state
    if (this.bothProductsSet()) {
      return (
        <BannerContainer>
          <Banner
            // title='You have added the maximum of 2 products per collection.  Click Done to continue or Change design below to customize a background image and other styling for this collection scene.'
            status='success'
            action={{content: 'Change design', size: 'slim', onClick: this.apply(true)}}
          >
            <Text size='large'>You have added the maximum of 2 products per collection.  Click Done to continue or Change design below to customize a background image and other styling for this collection scene.</Text>
          </Banner>
        </BannerContainer>
      )
    } else if (selectedCollection !== -1) {
      const collection = _.get(collections, parseInt(selectedCollection))
      // console.log('collection', collection, 'selectedCollection', selectedCollection, 'p0', p0, 'p1', p1)
      return (
        <CollectionProductsList
          collection={collection}
          pId0={_.get(p0, 'productId')}
          pId1={_.get(p1, 'productId')}
          onSelect={this.addProduct}
          onRemove={this.deleteProduct}
        />
      )
    }
  }

  renderContent () {
    return (
      <ContentContainer>
        {this.renderInputs()}
        {this.renderSceneProducts()}
        {this.renderCollectionProducts()}
        {this.renderProductsPicker()}
        {this.renderCollectionsPicker()}
      </ContentContainer>
    )
  }

  render () {
    // console.log('Products slide wizard showcase', this.state.showcase)
    // const { app, field, startAddCollection, handleSceneChange, editShowcaseIdx } = this.props
    return (
      <Wrapper key={this.uniqId}>
        <EditorContainer>
          <UICard
            width='40em'
            title={'Add Collection'}
            footerRight={this.renderRight()}
            content={this.renderContent()}
          />
        </EditorContainer>
      </Wrapper>
    )
  }

}

AddCollection.defatultProps = {
  collections: {}
}

AddCollection.propTypes = {
  app: PropTypes.object.isRequired, //eslint-disable-line
  editShowcaseIdx: PropTypes.number, //eslint-disable-line
  stopAddCollection: PropTypes.func.isRequired,
  integrationProducts: PropTypes.object.isRequired,
  collections: PropTypes.object
}

const mapStateToProps = state => ({
  integrationProducts: state.integrationProducts,
  collections: state.shopifyAppData.collections
})

export default connect(mapStateToProps)(AddCollection)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/AddCollection.js